import { render, staticRenderFns } from "./SettingsSubheader.vue?vue&type=template&id=13c15f04"
import script from "./SettingsSubheader.vue?vue&type=script&lang=js"
export * from "./SettingsSubheader.vue?vue&type=script&lang=js"
import style0 from "./SettingsSubheader.vue?vue&type=style&index=0&id=13c15f04&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c15f04')) {
      api.createRecord('13c15f04', component.options)
    } else {
      api.reload('13c15f04', component.options)
    }
    module.hot.accept("./SettingsSubheader.vue?vue&type=template&id=13c15f04", function () {
      api.rerender('13c15f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/subheader/SettingsSubheader.vue"
export default component.exports